export const areDeeplyEqual = (obj1, obj2, depth = Infinity) => {
    if (obj1 === obj2)
        return true;
    if (typeof obj1 !== typeof obj2)
        return false;
    if (typeof obj1 !== "object" || typeof obj2 !== "object")
        return false;
    const obj1Keys = Object.keys(obj1).sort();
    const obj2Keys = Object.keys(obj2).sort();
    if (obj1Keys.length !== obj2Keys.length)
        return false;
    for (let i = 0; i < obj1Keys.length; i++) {
        const key1 = obj1Keys[i];
        const key2 = obj2Keys[i];
        if (key1 !== key2)
            return false;
        if (obj1[key1] !== obj2[key2]) {
            if (depth <= 1)
                return false;
            if (!areDeeplyEqual(obj1[key1], obj2[key2], depth - 1)) {
                return false;
            }
        }
    }
    return true;
};
